import { mergeHead, type HeadDescriptor } from '../shared/seo/HeadDescriptor.js';
import { defaultHead } from '../shared/seo/defaultHead.js';
import { organizationJsonLd, websiteJsonLd, type SiteInfo } from '../shared/seo/jsonld.js';

/**
 * El `<head>` de la portada, compartido por el loader y la vista. La vista lo necesita para
 * cuando se **vuelve** a la portada desde una nota: sin eso, el `<title>` seguiría siendo el
 * de la nota anterior.
 */
export function headDeHome(site: SiteInfo): HeadDescriptor {
  return mergeHead(defaultHead(site, '/'), {
    title: `${site.name} — Noticias de la Patagonia`,
    description: `Portada de ${site.name}: últimas noticias, secciones y coberturas de la región.`,
    openGraph: { type: 'website' },
    jsonLd: [websiteJsonLd(site), organizationJsonLd(site)],
  });
}
